import * as React from "react";

import { cn } from "@/lib/utils.ts";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-full border border-input bg-popover px-3 py-2 text-sm md:text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-hidden kbd-nav:focus-visible:ring-2 kbd-nav:focus-visible:ring-ring kbd-nav:focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

/** Non-shad component, intended to wrap an Input and render a description */
const InputWrapper = ({
  children,
  description,
}: {
  children: React.ReactNode;
  description: string;
}) => {
  return (
    <div className="flex flex-col gap-2">
      {children}
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  );
};

/** Non-shad component, intended to wrap an a Label and either an Input or an InputWrapper. */
const LabelInput = ({
  orientation = "vertical",
  children,
}: {
  orientation?: "vertical" | "horizontal";
  children: React.ReactNode;
}) => {
  return (
    <div
      className={cn(
        "flex gap-2",
        orientation === "horizontal" ? "flex-row align-baseline gap-4" : "flex-col gap-2",
      )}
    >
      {children}
    </div>
  );
};

export { Input, InputWrapper, LabelInput };
